<template>
  <v-container>
    <v-layout row wrap>
      <v-flex d-flex xs12 child-flex>
        <h1 class="text-center" id="page-heading">Enter your details</h1>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex d-flex xs12 child-flex>
        <h2 class="text-center">For your chance to Win a <u><router-link to="/prizes" target="_blank" class="text-white">Train with Team GB sporting experience</router-link></u></h2>
      </v-flex>
    </v-layout>
    <Entry v-bind:is-desktop="isDesktop"/>    
  </v-container>
</template>

<script>
import Entry from '../forms/Entry'
export default {
  props: ['isDesktop'],
  name: 'Home',
  components: {
    Entry
  },
  data: () => ({
    
  }),
};
</script>
